import { VTextField } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { TEXT_FIELD } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: TEXT_FIELD,
    mixins: [ commonMixins ],
    render(h) {
        const {
            
             key,
             _type = 'text',
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             'click:clear': click_clear = defaultFun,
             'click:append': click_append = defaultFun,
             'keydown.enter': keydown_enter = defaultFun,
                // eslint-disable-next-line 
                slots,scopedSlots,
             ...params 
            } = this.field
        params.type = _type
        params.value = this.my_value[key]
        return h(VTextField, {
            props: params,
            slots: this.slots || slots || {},
            scopedSlots:  this.separateSlot && this.separateSlot() || scopedSlots || {},
            on: {
                'click:clear':(data) => {
                    this.my_value[key] = null
                    click_clear(data)
                },
                'click:append': (data) => {
                    click_append(data)
                },
                keydown: (data) => {
                    const key = data.key && data.key.toLowerCase()
                    switch (key) {
                        case 'enter':
                            keydown_enter(data)
                            break;
                        default:
                            break;
                    }
                    keydown()
                },
                blur,
                change,
                click,
                focus,
                input:(data) => {
                    this.my_value[key] = data
                    input(data)
                },
                mousedown,
                mouseup
            }
        })
    }
}